var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-message",class:_vm.feedbackClasses},[_c('transition',{attrs:{"name":"fade","mode":"out-in","tag":"span"}},[(_vm.message)?_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }